let hasError = ref(false);
let error = ref(undefined);
let errorMessage = ref(undefined);
let errorDetail = ref(undefined);
let idSuivi = ref(undefined);

export const useReportBug = () => {

    const reportBug = async () => {
        await useDirectus().customEndpoint({
            path:'/monday-api-proxy/report-bug',
            method:'POST',
            body:JSON.stringify({content:{error:error.value, errorDetail:errorDetail.value, idSuivi:idSuivi.value}}),
        })
    }

    const reset = async () => {
        hasError.value = false;
        error.value = undefined;
        errorMessage.value = undefined;
        errorDetail.value = undefined;
        idSuivi.value = undefined;
    }

    return {hasError, errorMessage, errorDetail, idSuivi, reportBug, error, reset};
}